// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimClaimGroupViewExtendedModel {
    static getAttributeTypeMap() {
        return ClaimClaimGroupViewExtendedModel.attributeTypeMap;
    }
}
ClaimClaimGroupViewExtendedModel.discriminator = undefined;
ClaimClaimGroupViewExtendedModel.additionalProperties = false;
ClaimClaimGroupViewExtendedModel.attributeTypeMap = [
    {
        "name": "status",
        "baseName": "status",
        "type": "string"
    },
    {
        "name": "paymentType",
        "baseName": "paymentType",
        "type": "string"
    },
    {
        "name": "processor",
        "baseName": "processor",
        "type": "string"
    },
    {
        "name": "claimGroupId",
        "baseName": "claimGroupId",
        "type": "number"
    },
    {
        "name": "parentClaimGroupId",
        "baseName": "parentClaimGroupId",
        "type": "number"
    },
    {
        "name": "claimGroupStatusId",
        "baseName": "claimGroupStatusId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "claimTypeId",
        "baseName": "claimTypeId",
        "type": "number"
    },
    {
        "name": "paymentBatchId",
        "baseName": "paymentBatchId",
        "type": "number"
    },
    {
        "name": "paymentBatchStatusId",
        "baseName": "paymentBatchStatusId",
        "type": "number"
    },
    {
        "name": "paymentMethodTypeId",
        "baseName": "paymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "Date"
    },
    {
        "name": "processedBy",
        "baseName": "processedBy",
        "type": "number"
    },
    {
        "name": "initialCost",
        "baseName": "initialCost",
        "type": "number"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "number"
    },
    {
        "name": "remainingCost",
        "baseName": "remainingCost",
        "type": "number"
    },
    {
        "name": "checkNumber",
        "baseName": "checkNumber",
        "type": "string"
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "prescriberName",
        "baseName": "prescriberName",
        "type": "string"
    },
    {
        "name": "siteNpi",
        "baseName": "siteNpi",
        "type": "string"
    },
    {
        "name": "siteName",
        "baseName": "siteName",
        "type": "string"
    },
    {
        "name": "siteZip",
        "baseName": "siteZip",
        "type": "string"
    },
    {
        "name": "claimBatchNumber",
        "baseName": "claimBatchNumber",
        "type": "string"
    },
    {
        "name": "claimNumber",
        "baseName": "claimNumber",
        "type": "string"
    },
    {
        "name": "drugName",
        "baseName": "drugName",
        "type": "string"
    },
    {
        "name": "processorGroupNumber",
        "baseName": "processorGroupNumber",
        "type": "string"
    },
    {
        "name": "priorAuthorizationNumber",
        "baseName": "priorAuthorizationNumber",
        "type": "string"
    },
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "number"
    },
    {
        "name": "otherCoverageCode",
        "baseName": "otherCoverageCode",
        "type": "string"
    },
    {
        "name": "averageWholesalePrice",
        "baseName": "averageWholesalePrice",
        "type": "number"
    },
    {
        "name": "usualAndCustomaryCost",
        "baseName": "usualAndCustomaryCost",
        "type": "number"
    },
    {
        "name": "ingredientCost",
        "baseName": "ingredientCost",
        "type": "number"
    },
    {
        "name": "salesTax",
        "baseName": "salesTax",
        "type": "number"
    },
    {
        "name": "abfEobNumber",
        "baseName": "abfEobNumber",
        "type": "string"
    },
    {
        "name": "abfCheckNumber",
        "baseName": "abfCheckNumber",
        "type": "string"
    },
    {
        "name": "rxWrittenDate",
        "baseName": "rxWrittenDate",
        "type": "Date"
    },
    {
        "name": "dispensingFee",
        "baseName": "dispensingFee",
        "type": "number"
    },
    {
        "name": "claims",
        "baseName": "claims",
        "type": ""
    },
];
//# sourceMappingURL=claimClaimGroupViewExtendedModel.js.map